export default __webpack_public_path__ + "static/media/login_img.c7f6148d.svg";